<template>
    <v-col cols="12">
        <v-dialog v-if="isAdmin" transition="scale-transition" origin="center center" scrollable max-width="784px"
            v-model="dialog" class="custom-dialog">
            <template v-slot:activator="{ on, attrs }">
                <v-btn @click="openDialog" large tile block elevation="0" class="ma-0 text-capitalize btn-account"
                    color="greenMain" height="48px" v-bind="attrs" v-on="on">
                    Add New
                </v-btn>
            </template>
            <v-card class="rounded-0 px-0" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                <v-stepper v-model="step" class="password-stepper admin-password-stepper">
                    
                    <template v-if="admin.accessType === 'Custom Access' && step >= 2">
                        <v-stepper-header class="pt-3 px-5">

                            <template v-for="(stepNumber, index) in stepNumbers">

                                <v-stepper-step :step="stepNumber" :complete="step > stepNumber"
                                    :color="stepNumber === totalSteps ? '#708AA7' : 'greenMain'" />

                                <!-- divider between steps -->
                                <v-divider v-if="index !== stepNumbers.length - 1" :key="'divider-' + index" />
                            </template>

                        </v-stepper-header>
                    </template>

                    <v-stepper-items>
                        <v-stepper-content step="1" class="custom-stepper-content pt-3 px-5">

                            <v-card-title class="pb-3 text-left justify-start pl-0">
                                Add
                                <span v-if="this.loggedAdmin?.is_dev === 1">Admin / </span>
                                Manager
                            </v-card-title>

                            <v-card-subtitle class="mt-0 pl-0 pb-0 pr-10 text--ash">
                                You Can Add <span v-if="this.loggedAdmin?.is_dev === 1">Admin / </span>Manager From Here
                            </v-card-subtitle>

                            <v-card class="deposit-form password-field admin-deposit-form"
                                :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">

                                <v-form ref="form">
                                    <v-row>

                                        <!-- FIRST NAME -->
                                        <v-col cols="12" sm="12" md="12" lg="6">
                                            <fieldset>
                                                <legend>First Name*</legend>
                                                <v-text-field v-model="admin.firstName" label="First Name" type="text"
                                                    single-line solo class="custom-select" />
                                            </fieldset>
                                            <span v-if="!admin.firstName && error.firstName"
                                                style="color:red;font-size:12px">
                                                {{ error.firstName }}
                                            </span>
                                        </v-col>

                                        <!-- LAST NAME -->
                                        <v-col cols="12" sm="12" md="12" lg="6">
                                            <fieldset>
                                                <legend>Last Name*</legend>
                                                <v-text-field v-model="admin.lastName" label="Last Name" type="text"
                                                    single-line solo class="custom-select" />
                                            </fieldset>
                                            <span v-if="!admin.lastName && error.lastName"
                                                style="color:red;font-size:12px">
                                                {{ error.lastName }}
                                            </span>
                                        </v-col>

                                        <!-- ROLE -->
                                        <v-col cols="12" sm="12" md="12" lg="6">
                                            <fieldset>
                                                <legend>Role*</legend>
                                                <v-select v-model="admin.role"
                                                    :items="loggedAdmin?.is_dev === 1 || loggedAdmin?.access_type === 'admin' ? ['Manager', 'Admin'] : ['Manager']"
                                                    label="Select Role" solo class="custom-select" />
                                            </fieldset>
                                            <span v-if="!admin.role && error.role" style="color:red;font-size:12px">
                                                {{ error.role }}
                                            </span>
                                        </v-col>

                                        <!-- EMAIL -->
                                        <v-col cols="12" sm="12" md="12" lg="6">
                                            <fieldset>
                                                <legend>Email*</legend>
                                                <v-text-field v-model="admin.email" label="Email" type="email"
                                                    single-line solo class="custom-select" />
                                            </fieldset>
                                            <span v-if="!admin.email && error.email" style="color:red;font-size:12px">
                                                {{ error.email }}
                                            </span>
                                        </v-col>

                                        <!-- PASSWORD -->
                                        <v-col cols="12" sm="12" md="12" lg="6">
                                            <fieldset>
                                                <legend>Password*</legend>
                                                <v-text-field v-model="admin.password"
                                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    @click:append="showPassword = !showPassword" label="Password"
                                                    single-line solo class="custom-select" />
                                            </fieldset>
                                            <span v-if="!admin.password && error.password"
                                                style="color:red;font-size:12px">
                                                {{ error.password }}
                                            </span>
                                        </v-col>

                                        <!-- CONFIRM PASSWORD -->
                                        <v-col cols="12" sm="12" md="12" lg="6">
                                            <fieldset>
                                                <legend>Confirm Password*</legend>
                                                <v-text-field v-model="admin.confirmPassword"
                                                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                    :type="showConfirmPassword ? 'text' : 'password'"
                                                    @click:append="showConfirmPassword = !showConfirmPassword"
                                                    label="Confirm Password" single-line solo class="custom-select" />
                                            </fieldset>
                                            <span v-if="!admin.confirmPassword && error.confirmPassword"
                                                style="color:red;font-size:12px">
                                                {{ error.confirmPassword }}
                                            </span>
                                            <span v-if="error.passwordMatch" style="color:red;font-size:12px">
                                                {{ error.passwordMatch }}
                                            </span>
                                        </v-col>

                                        <!-- COUNTRY ACCESS -->
                                        <v-col cols="12" sm="12" md="12" lg="6">
                                            <fieldset>
                                                <legend>Country Access*</legend>
                                                <v-autocomplete v-model="admin.countryAccess"
                                                    :items="[{ id: 'all', name: 'All Countries' }, ...countries]"
                                                    item-text="name" item-value="id" label="Country Access" multiple
                                                    chips deletable-chips single-line solo class="custom-select"
                                                    @change="handleCountrySelection" />
                                            </fieldset>
                                            <span v-if="!admin.countryAccess && error.countryAccess"
                                                style="color:red;font-size:12px">
                                                {{ error.countryAccess }}
                                            </span>
                                        </v-col>

                                        <!-- ACCESS TYPE -->
                                        <v-col cols="12" sm="12" md="12" lg="6">
                                            <fieldset>
                                                <legend>Access Type*</legend>
                                                <v-select @change="handleAccessTypeChange" v-model="admin.accessType"
                                                    :items="['Full Control', 'Read Only', 'Custom Access']"
                                                    label="Access Type" solo class="custom-select" />
                                            </fieldset>
                                            <span v-if="!admin.accessType && error.accessType"
                                                style="color:red;font-size:12px">
                                                {{ error.accessType }}
                                            </span>
                                        </v-col>

                                    </v-row>

                                    <!-- ACTION BUTTONS -->
                                    <v-col cols="12" sm="12" md="12" lg="6" class="px-0">
                                        <v-btn v-if="admin.accessType !== 'Custom Access'" tile elevation="0"
                                            class="text-capitalize btn-account mr-3 px-sm-8" :loading="loading" :disabled="loading" color="greenMain"
                                            @click.prevent="submitForm">
                                            Save
                                        </v-btn>

                                        <v-btn v-else class="text-capitalize btn-account" color="greenMain" tile
                                            elevation="0" @click="nextStep">
                                            Next Step
                                        </v-btn>
                                    </v-col>

                                </v-form>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content v-for="(stepModules, index) in permissionData" :key="'perm-step-' + index"
                            :step="index + 2" class="custom-stepper-content pt-3 px-0">

                            <v-card-text class="title-bar px-5 pt-0">
                                <v-card-title class="pb-1 text-left justify-start pl-0">
                                    Custom Access
                                    <small class="ml-1">For <span>{{ admin.firstName + ' ' + admin.lastName
                                            }}</span></small>
                                </v-card-title>

                                <v-card-subtitle class="mt-0 pl-0 pb-0 pr-10 text--ash">
                                    Set Custom Access For Selected User
                                </v-card-subtitle>
                            </v-card-text>


                            <v-form>
                                <v-card class="deposit-form admin-deposit-form mt-0 px-0" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                                    <v-row dense no-gutters>
                                        <v-col cols="12" class="px-0">

                                            <div v-for="module in stepModules" :key="'mod-' + module.moduleId"
                                                class="custom-access-stepper">

                                                <!-- MODULE TITLE + RADIO -->
                                                <v-row align="center" dense no-gutters class="pt-9 pb-8">

                                                    <v-col cols="12" sm="6" md="5">
                                                        <h3>
                                                            <v-icon color="#039de9" small class="mr-3">{{ module.icon
                                                                }}</v-icon>
                                                            {{ module.moduleName }}
                                                        </h3>
                                                    </v-col>

                                                    <v-col cols="12" sm="6" md="7" class="mb-5">
                                                        <v-radio-group v-model="module.moduleAccess" row hide-details>
                                                            <v-radio v-for="option in getModuleOptions(module)"
                                                                :key="option" :label="option" :value="option"
                                                                color="teal" class="custom-radio-buttons" />
                                                        </v-radio-group>
                                                    </v-col>

                                                </v-row>


                                                <!-- SUB-MODULES -->
                                                <v-row v-if="module.moduleAccess === 'Custom'" align="center" dense
                                                    no-gutters>

                                                    <v-card-subtitle class="text pb-4 px-0 pt-0">
                                                        You are giving access to these pages
                                                    </v-card-subtitle>

                                                    <v-card-text class="pb-8">
                                                        <div class="chips">

                                                            <div v-for="sub in module.subModules" :key="'sub-' + sub.id"
                                                                class="chips-details">

                                                                <span>{{ sub.name }}</span>

                                                                <v-select v-model="sub.access"
                                                                    :items="['Full Control', 'Read Only', 'No Access']"
                                                                    solo hide-details append-icon="mdi-chevron-down"
                                                                    class="custom-select" />

                                                            </div>

                                                        </div>
                                                    </v-card-text>
                                                </v-row>

                                            </div>

                                        </v-col>
                                    </v-row>

                                </v-card>

                                <div class="px-5 py-12">
                                    <v-btn class="text-capitalize btn-account mr-3" color="greenMain" tile elevation="0"
                                        @click="prevStep">
                                        Back
                                    </v-btn>

                                    <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                                        @click="nextStep">
                                        Next Step
                                    </v-btn>
                                </div>

                            </v-form>
                        </v-stepper-content>

                        <v-stepper-content :step="totalSteps" class="custom-stepper-content pt-3 px-5">

                            <v-form>
                                <v-card class="deposit-form admin-deposit-form mt-0 px-0"
                                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">

                                    <v-row dense no-gutters>
                                        <v-col cols="12" class="px-0">
                                            <div class="last-steps">
                                                <h1>Are You Sure ?</h1>
                                                <h4>You want to save all the changes of custom access?</h4>
                                            </div>

                                            <v-img src="@/assets/login.png" max-height="207" max-width="219"
                                                class="mx-auto mb-10"></v-img>
                                        </v-col>
                                    </v-row>

                                    <div class="px-5 py-12 text-center">
                                        <v-btn class="text-capitalize btn-account mr-3" color="greenMain" tile
                                            elevation="0" @click="prevStep">
                                            Back
                                        </v-btn>

                                        <v-btn class="text-capitalize btn-account" color="#FF567F" tile elevation="0" :loading="loading" :disabled="loading"
                                            @click.prevent="submitForm">
                                            Save & Close
                                        </v-btn>
                                    </div>

                                </v-card>
                            </v-form>

                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card>
        </v-dialog>

        <v-btn v-else large tile block elevation="0" class="ma-0 text-capitalize btn-account"
            color="greenMain" disabled height="48px" v-bind="attrs" v-on="on">
            Add New
        </v-btn>
    </v-col>
</template>

<script>
import { ADMINS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
    data() {
        return {
            search: "",
            dialog: false,
            loading: false,
            showPassword: false,
            showConfirmPassword: false,
            permissionData: [],
            step: 1,
            error: {
                firstName: "",
                lastName: "",
                email: "",
                password: "",
                confirmPassword: "",
                role: "",
                countryAccess: "",
                accessType: "",
                passwordMatch: ""
            },
            admin: {
                firstName: "",
                lastName: "",
                email: "",
                password: "",
                confirmPassword: "",
                role: '',
                countryAccess: null,
                accessType: "",
            },
        };
    },

    computed: {
        ...mapState("admins", ["loggedAdmin", "admins", "countries", "allModulesAndSubmodules"]),

        isAdmin() {
            return (
                this.loggedAdmin && this.loggedAdmin?.access_type === "admin"
            );
        },

        stepNumbers() {
            return Array.from({ length: this.totalSteps }, (_, i) => i + 1);
        },

        totalSteps() {
            return 1 + this.permissionData.length + 1;
        },

    },

    watch: {
        allModulesAndSubmodules: {
            handler() {
                this.buildPermissionData();
            },
            immediate: true
        }
    },

    methods: {
        ...mapActions("admins", [
            ADMINS__ACTIONS.GETADMINS,
            ADMINS__ACTIONS.CREATEADMIN,
            ADMINS__ACTIONS.GETALLMODULES,
            ADMINS__ACTIONS.GETROLES
        ]),

        getModuleOptions(module) {
            if (module.subModules.length > 1) {
                return ['Full Control', 'Read Only', 'No Access', 'Custom'];
            }
            return ['Full Control', 'Read Only', 'No Access'];
        },

        resetSections() {
            this.admin.firstName = "";
            this.admin.lastName = "";
            this.admin.email = "";
            this.admin.password = "";
            this.admin.confirmPassword = "";
            this.admin.role = "";
            this.admin.countryAccess = null;
            this.admin.accessType = "";
            this.buildPermissionData();
            this.error = {
                firstName: "",
                lastName: "",
                email: "",
                password: "",
                confirmPassword: "",
                role: "",
                countryAccess: "",
                accessType: "",
                passwordMatch: ""
            };
        },

        openDialog() {
            this.step = 1;
            this.resetSections();
            this.dialog = true
        },

        nextStep() {
            if (this.admin.firstName === null || this.admin.firstName.trim() === "") {
                this.error.firstName = "First name field is required";
            } else {
                this.error.firstName = null;
            }

            if (this.admin.lastName === null || this.admin.lastName.trim() === "") {
                this.error.lastName = "Last Name field is required";
            } else {
                this.error.lastName = null;
            }

            if (this.admin.email === null || this.admin.email.trim() === "") {
                this.error.email = "Email field is required";
            } else {
                this.error.email = null;
            }

            if (this.admin.password === null || this.admin.password.trim() === "") {
                this.error.password = "Password field is required";
            } else {
                this.error.password = null;
            }

            if (this.admin.confirmPassword === null || this.admin.confirmPassword.trim() === "") {
                this.error.confirmPassword = "Confirm Password field is required";
            } else {
                this.error.confirmPassword = null;
            }

            if (this.admin.password !== this.admin.confirmPassword) {
                this.error.passwordMatch = "Password do not match";
            } else {
                this.error.passwordMatch = null;
            }

            if (this.admin.role === null || this.admin.role.trim() === "") {
                this.error.role = "Role field is required";
            } else {
                this.error.role = null;
            }

            if (this.admin.accessType === null || this.admin.accessType.trim() === "") {
                this.error.accessType = "Access type field is required";
            } else {
                this.error.accessType = null;
            }

            if (this.admin.countryAccess === null) {
                this.error.countryAccess = "Country access field is required";
            } else {
                this.error.countryAccess = null;
            }

            if (
                !this.error.firstName &&
                !this.error.lastName &&
                !this.error.email &&
                !this.error.password &&
                !this.error.confirmPassword &&
                !this.error.role &&
                !this.error.countryAccess &&
                !this.error.accessType &&
                !this.error.passwordMatch
            ) {
                if (this.step < this.totalSteps) this.step++
            }
        },

        prevStep() {
            if (this.step > 1) this.step--
        },

        buildPermissionData() {
            const modules = this.allModulesAndSubmodules;
            const chunkSize = 500;
            const temp = [];

            modules.forEach(module => {
                temp.push({
                    moduleId: module.id,
                    moduleName: module.module,
                    icon: module.icon,
                    moduleAccess: "Full Control",
                    subModules: module.subModules.map(sub => ({
                        id: sub.id,
                        name: sub.name,
                        access: "No Access"
                    }))
                });
            });

            const chunks = [];
            for (let i = 0; i < temp.length; i += chunkSize) {
                chunks.push(temp.slice(i, i + chunkSize));
            }

            this.permissionData = chunks;
        },

        mapAccess(text) {
            switch (text) {
                case "Full Control": return 1;
                case "Read Only": return 2;
                case "Custom": return 3;
                case "No Access": return 0;
                default: return 0;
            }
        },

        buildPermissionPayload() {
            const output = {};

            this.permissionData.forEach(group => {
                group.forEach(module => {
                    const moduleAccess = this.mapAccess(module.moduleAccess);

                    const subPayload = {};
                    module.subModules.forEach(sub => {
                        subPayload[sub.id] =
                            module.moduleAccess === "Custom"
                                ? this.mapAccess(sub.access)
                                : moduleAccess;
                    });

                    output[module.moduleId] = {
                        access: moduleAccess,
                        subModules: subPayload
                    };
                });
            });

            return output;
        },

        applyGlobalAccess(accessValue) {
            if (!this.permissionData || this.permissionData.length === 0) return;

            this.permissionData.forEach(group => {
                group.forEach(module => {
                    module.moduleAccess = 
                        accessValue === 1 ? "Full Control" :
                        accessValue === 2 ? "Read Only" : "No Access";

                    module.subModules.forEach(sub => {
                        sub.access =
                            accessValue === 1 ? "Full Control" :
                            accessValue === 2 ? "Read Only" : "No Access";
                    });

                });
            });
        },

        handleAccessTypeChange(type) {
            if (type === "Full Control") {
                this.applyGlobalAccess(1);
            } 
            else if (type === "Read Only") {
                this.applyGlobalAccess(2);
            } 
            else if (type === "Custom Access") {
                return;
            }
        },

        handleCountrySelection(selection) {
            if (!selection) {
                this.admin.countryAccess = [];
                this.error.countryAccess = "Country access field is required";
                return;
            }

            // If "All" is selected, clear other selections
            if (selection.includes('all')) {
                this.admin.countryAccess = ['all'];
                return;
            }

            // Remove 'all' if other countries are selected
            this.admin.countryAccess = selection.filter(item => item !== 'all');
        },

        async submitForm() {
            this.loading = true;
            try {
                if (!this.admin.firstName?.trim()) {
                    this.error.firstName = "First name field is required";
                } else this.error.firstName = null;

                if (!this.admin.lastName?.trim()) {
                    this.error.lastName = "Last Name field is required";
                } else this.error.lastName = null;

                if (!this.admin.role?.trim()) {
                    this.error.role = "Role field is required";
                } else this.error.role = null;

                if (!this.admin.email?.trim()) {
                    this.error.email = "Email field is required";
                } else this.error.email = null;

                if (!this.admin.password?.trim()) {
                    this.error.password = "Password field is required";
                } else this.error.password = null;

                if (!this.admin.confirmPassword?.trim()) {
                    this.error.confirmPassword = "Confirm Password field is required";
                } else this.error.confirmPassword = null;

                if (this.admin.password !== this.admin.confirmPassword) {
                    this.error.passwordMatch = "Password do not match";
                } else this.error.passwordMatch = null;

                if (!this.admin.countryAccess) {
                    this.error.countryAccess = "Country access field is required";
                } else this.error.countryAccess = null;

                if (!this.admin.accessType?.trim()) {
                    this.error.accessType = "Access type field is required";
                } else this.error.accessType = null;

                const formattedCountryAccess =
                    this.admin.countryAccess.includes("all")
                        ? this.countries.map(c => c.id).join(",")
                        : this.admin.countryAccess.join(",");

                const permissions =
                    this.admin.accessType === "Custom Access"
                        ? this.buildPermissionPayload()
                        : this.buildPermissionPayload();  

                const data = {
                    adminData: {
                        ...this.admin,
                        countryAccess: formattedCountryAccess
                    },
                    permissions
                };

                await this[ADMINS__ACTIONS.CREATEADMIN](data);

                this.resetSections();
                this.dialog = false;

            } catch (error) {
                console.error("Error submitting form:", error);

            } finally {
                this.loading = false;
            }
        }
    },

    async created() {
        await this[ADMINS__ACTIONS.GETADMINS]();
        await this[ADMINS__ACTIONS.GETALLMODULES]();
        await this[ADMINS__ACTIONS.GETROLES]();
        await this.buildPermissionData();
    },
};
</script>

<style scoped>
.custom-dialog .v-card {
    max-height: 100vh;
    overflow-y: auto;
}

.custom-stepper-content {
    max-height: calc(100vh - 150px);
    overflow-y: auto;
    padding-bottom: 16px;
}
</style>